import { validations } from "utils/validations";
import { IPersonalDetails, SocialResponse } from "./types";

export const getPersonalDetailsErrors = (personalDetails: IPersonalDetails) => {
    let hasError = false;
    let errors: IPersonalDetails = {
        first_name: "",
        last_name: "",
        gender: "",
        nationality: "",
        qualification: "",
        dob: "",
    };

    Object.keys(personalDetails).forEach((key) => {
        const error = validations(
            key,
            personalDetails[key as keyof typeof personalDetails]
        );

        if (error !== "") {
            hasError = true;
            errors[key as keyof typeof errors] = error;
        }
    });

    return {
        hasError,
        errors,
    };
};

export const getSocialLinkWithErrors = (socialLinks: SocialResponse[]) => {
    let hasError = false;

    const updatedLinks = socialLinks.map((link) => {
        const error = validations("socialUserName", link.username);

        if (error !== "") {
            hasError = true;
        }

        return {
            ...link,
            error,
        };
    });

    return { hasError, updatedLinks };
};
